import { Box, Typography } from "@mui/material";
import { SxProps } from "@mui/material/styles";
import { ReactNode } from "react";
import {
  colorSurface,
  colorBorder,
  colorTextPrimary,
  colorTextMuted,
  shadowCard,
  radiusCard,
} from "./tokens";

interface InfoCardProps {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  /** Caller overrides on the card's outer box, e.g. `height: "100%"`. */
  sx?: SxProps;
}

export const InfoCard = ({ title, subtitle, icon, action, children, sx }: InfoCardProps) => (
  <Box
    sx={{
      backgroundColor: colorSurface,
      border: `1px solid ${colorBorder}`,
      borderRadius: radiusCard,
      boxShadow: shadowCard,
      ...sx,
    }}
  >
    <Box sx={{ px: 3, pt: 2.5, pb: 2, borderBottom: `1px solid ${colorBorder}` }}>
      <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
        <Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: subtitle ? 0.5 : 0 }}>
            {icon && (
              <Box sx={{ color: colorTextMuted, display: "flex", alignItems: "center" }}>
                {icon}
              </Box>
            )}
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, color: colorTextPrimary, lineHeight: 1.4 }}
            >
              {title}
            </Typography>
          </Box>
          {subtitle && (
            <Typography variant="body2" sx={{ color: colorTextMuted, ml: icon ? 3.5 : 0 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {action && <Box sx={{ ml: 2, flexShrink: 0 }}>{action}</Box>}
      </Box>
    </Box>
    <Box sx={{ px: 3, py: 2.5 }}>{children}</Box>
  </Box>
);
